import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { useWagmiAuth } from 'app/providers';
import { userModel } from 'entities/user';
import { COLOR_ACCENT, fromDecimals, getToastMessage, Icons, ReferralTip, useShallowSelector } from 'shared';
import { ArrowAccordion } from 'shared/ui/Icon';

const constructRefLink = (address: string) => {
  return `${window.location.origin}/${address}`;
};

export const ReferralLinkAccordion = () => {
  const { state: authState } = useWagmiAuth();
  const { referralReceived } = useShallowSelector(userModel.selectors.selectUserCrowdsaleInfo);
  const link = constructRefLink(authState.address);

  const handleCopyReferral = () => {
    getToastMessage('success', 'Referral link copied');
  };

  return (
    <Accordion className="secondary">
      <AccordionSummary expandIcon={<ArrowAccordion />}>
        <Stack direction="row" spacing={1}>
          <Typography className="secondary">Your referral link</Typography>
          <ReferralTip />
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Stack alignItems="center" spacing={1}>
          <TextField
            value={constructRefLink(authState.address)}
            InputProps={{
              readOnly: true,
              inputProps: { className: 'secondary' },
              endAdornment: (
                <InputAdornment position="end">
                  <CopyToClipboard onCopy={handleCopyReferral} text={link}>
                    <IconButton className="transparent">
                      <Icons.Copy
                        sx={{
                          color: COLOR_ACCENT,
                        }}
                      />
                    </IconButton>
                  </CopyToClipboard>
                </InputAdornment>
              ),
            }}
          />
          <Typography textAlign="center" className="secondary">
            Referral rewards earned:{' '}
            <Typography component="span" variant="inherit">
              {fromDecimals(referralReceived)} USDT
            </Typography>
          </Typography>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};
